import React from 'react';
import Icon from '../AppIcon';

const ProgressIndicator = ({ 
currentStep, 
totalSteps, 
steps = [],
className = '' 
}) => {
const progressPercentage = ((currentStep) / totalSteps) * 100;
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

return (
<div className={`progress-indicator ${isMobile ? 'progress-indicator-mobile' : ''} ${className}`}>
<div className="max-w-5xl mx-auto">
<div className="flex items-center justify-between mb-4">
<div className="flex items-center gap-2">
<span className="text-sm font-medium text-muted-foreground">
Step {currentStep} of {totalSteps}
</span>
</div>
<div className="text-sm font-semibold text-primary">
{Math.round(progressPercentage)}% Complete
</div>
</div>

<div className="progress-bar mb-6">
<div 
className="progress-bar-fill" 
style={{ width: `${progressPercentage}%` }}
/>
</div>

{!isMobile && steps?.length > 0 && (
<div className="flex items-center justify-between gap-2">
{steps?.map((step, index) => {
const stepNumber = index + 1;
const isCompleted = stepNumber < currentStep;
const isCurrent = stepNumber === currentStep;
const isPending = stepNumber > currentStep;

return (
<div key={step?.stepId} className="progress-step flex-1">
<div className="flex items-center gap-3">
<div 
className={`progress-step-circle ${
isCompleted ? 'completed' : isCurrent ? 'current' : 'pending'
}`}
>
{isCompleted ? (
<Icon name="Check" size={20} />
) : (
<span className="text-sm font-semibold">{stepNumber}</span>
)}
</div>
<div className="flex-1 min-w-0">
<div 
className={`progress-step-label truncate ${
  isCompleted ? 'completed' : isCurrent ? 'current' : 'pending'
}`}
>
{step?.stepLabel}
</div>
</div>
</div>
</div>
);
})}
</div>
)}

{isMobile && steps?.length > 0 && (
<div className="flex items-center gap-3">
<div 
className={`progress-step-circle ${
steps?.[currentStep - 1] ? 'current' : 'pending'
}`}
>
<span className="text-sm font-semibold">{currentStep}</span>
</div>
<div className="flex-1">
<div className="progress-step-label current text-base">
{steps?.[currentStep - 1]?.stepLabel || 'Loading...'}
</div>
</div>
</div>
)}
</div>
</div>
);
};

export default ProgressIndicator;